@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Restocking'"
      [customBack]="backPage"
      [canGoBack]="!windowService.isDesktopRes"
      [showLinkIcon]="true"
      [linkIcon]="'add-circle'"
      (linkAction)="goToAddRoomItemPage()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [isPrimaryLayer]="true">
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header class="no-bottom-margin">
        <div class="wrappable-container">
          <tidy-text
            [title]="'Restocking'" />
          <tidy-tabs
            [tabs]="tabs"
            [activeTab]="selectedTab"
            (tabChange)="selectTab($event)" />
        </div>
      </tidy-desktop-header>

      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [header]="selectedTab === 'orders' ? 'Orders' : 'Items'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/img/search-header.svg'"
              class="header-search" />
          </form>
          @if (addressItems?.length > 1) {
            <form [formGroup]="propertyForm" novalidate action="#">
              <tidy-header-select
                [items]="addressItems"
                [form]="propertyForm.get('property')"
                formControlName="property"
                (optionChange)="changeProperty()"
                [icon]="'assets/svg/home.svg'" />
            </form>
          }
          @if (selectedTab === 'orders') {
            <tidy-small-button
              [text]="'Create Order'"
              [image]="'assets/svg/cart-outline.svg'"
              (buttonClick)="goToOrderStock()" />
          }
          @if (selectedTab === 'items') {
            <tidy-small-button
              [text]="'Add Item'"
              [image]="'assets/img/add-button-white.svg'"
              (buttonClick)="goToAddRoomItemPage()" />
            <tidy-image
              [src]="'assets/img/download_csv.svg'"
              class="desktop-header-icon secondary-text-icon"
              (action)="exportCSV()"/>
          }
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
          }
          <automations-preview-button
            [tag]="'restocking'" />
        </div>
      </tidy-desktop-header>
    }

    <!--<ng-container *ngIf="loaded">
    <div style="display: flex; align-items: center;">
      <tidy-text
        [pageTitle]="'Inventory'">
      </tidy-text>
      <div style="display: flex; background: #E4E6E9; border: 0.5px solid #D5D5D5; border-radius: 4px; padding: 5px 10px; margin-left: 15px; cursor: pointer;">
        <tidy-image
          [src]="'assets/img/inventory-list.svg'">
        </tidy-image>
        <div style="font-family: 'Inter',Arial,sans-serif; font-weight: 300; font-size: 14px; color: #000;">
          All ({{rows?.length}})
        </div>
      </div>
      <div style="display: flex; border: 0.5px solid #D5D5D5; border-radius: 4px; padding: 5px 10px; margin-left: 10px; cursor: pointer;">
        <tidy-image
          [src]="'assets/svg/alert-circle-outline.svg'">
        </tidy-image>
        <div style="font-family: 'Inter',Arial,sans-serif; font-weight: 300; font-size: 14px; color: #000;">
          Low Stock (0)
        </div>
      </div>
      <tidy-image
        [src]="'assets/svg/add-outline.svg'"
        style="margin-left: 10px; width: 20px; height: 20px; cursor: pointer;"
        (action)="goToAddRoomItemPage()">
      </tidy-image>
    </div>
    <tidy-divider style="margin-left: -20px; margin-right: -20px; margin-top: 10px; margin-bottom: 10px;"></tidy-divider>
    <div style="display: flex; align-items: center;">
      <tidy-image
        [src]="'assets/svg/filter-outline.svg'"
        style="margin-right: 10px; width: 18px; cursor: pointer;">
      </tidy-image>
      <div style="font-family: 'Inter',Arial,sans-serif; font-weight: 300; font-size: 14px; color: #000;">
        Filter
      </div>
    </div>
    <tidy-divider style="margin-left: -20px; margin-right: -20px; margin-top: 10px; margin-bottom: 10px;"></tidy-divider>
  </ng-container>-->


  <!--<tidy-desktop-header *ngIf="windowService?.isDesktopRes">

  <ng-container *ngIf="loaded">

    <div class="desktop-nav-search">
      <form [formGroup]="form" novalidate action="#">
        <tidy-input
          #searchInput
          class="search-input"
          [icon]="'assets/svg/search-outline.svg'"
          [activeIcon]="'assets/svg/search-tidy-green.svg'"
          [noBorder]="true"
          type="search"
          formControlName="search"
          [label]="'Search'"
          [form]="form">
        </tidy-input>
      </form>
    </div>
    <form [formGroup]="propertyForm" novalidate action="#" class="form-filters">
      <tidy-select
        style="width: 200px"
        class="select-custom-input"
        [items]="addressItems"
        [form]="propertyForm.get('property')"
        formControlName="property"
        (optionChange)="changeProperty()">
      </tidy-select>
    </form>
    <tidy-image
      [src]="'assets/svg/add-outline.svg'"
      style="width: 20px; height: 20px; cursor: pointer;"
      (action)="goToAddRoomItemPage()">
    </tidy-image>
  </ng-container>
  <ng-container *ngIf="!loaded">
    <ion-skeleton-text
      animated="true"
          style="
            width: 320px;
            height: 40px;
            border-radius: 6px;">
    </ion-skeleton-text>
  </ng-container>
  <ion-spinner *ngIf="showLoadingSpinner" name="lines" class="header-loading-spinner"></ion-spinner>
</tidy-desktop-header>-->

@if (!windowService?.isDesktopRes) {
  <tidy-tabs
    [tabs]="tabs"
    [activeTab]="selectedTab"
    (tabChange)="selectTab($event)" />
  @if (addressItems?.length > 1) {
    <form [formGroup]="propertyForm" novalidate action="#" class="form-filters">
      <tidy-header-select
        [items]="addressItems"
        [form]="propertyForm.get('property')"
        formControlName="property"
        (optionChange)="changeProperty()"
        [icon]="'assets/svg/home.svg'" />
    </form>
  }
  <form [formGroup]="form" novalidate action="#">
    <tidy-search-input
      formControlName="search"
      [placeholder]="'Search'"
      [icon]="'assets/img/search-header.svg'"
      class="header-search" />
  </form>
  @if (selectedTab === 'orders') {
    <tidy-row>
      <tidy-button
        [text]="'Create Order'"
        [action]="boundGoToOrderStock"
        class="secondary" />
    </tidy-row>
  }
}

@if (selectedTab === 'orders') {
  <!-- Loading skeleton: the real lane headers with grey placeholder cards
       (address tag + name, title line, meta line) so the board structure
       is visible immediately and the data swaps in without shifting. -->
  @if (!loaded) {
    <div class="restock-skeleton">
      @for (lane of orderLaneConfig; track lane.id; let i = $index) {
        <div class="restock-lane">
          <div class="restock-lane-header">
            <tidy-image
              [src]="lane.icon"
              class="body-size" />
            <tidy-text
              [header]="lane.label" />
            <div class="restock-lane-rule"></div>
          </div>
          <div class="restock-lane-grid">
            @for (card of skeletonLaneCards[i]; track card) {
              <tidy-card class="restock-order-card">
                <div class="restock-line-row">
                  <ion-skeleton-text [animated]="true" class="restock-skel-icon" />
                  <ion-skeleton-text [animated]="true" class="restock-skel-name" />
                </div>
                <div class="restock-line-row">
                  <ion-skeleton-text [animated]="true" class="restock-skel-text" />
                </div>
                <div class="restock-line-row">
                  <ion-skeleton-text [animated]="true" class="restock-skel-text-sm" />
                </div>
              </tidy-card>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (loaded) {
  @for (lane of orderLanes; track lane.id) {
    <div class="restock-lane">
      <div class="restock-lane-header">
        <tidy-image
          [src]="lane.icon"
          class="body-size" />
        <tidy-text
          [header]="lane.label" />
        <tidy-text
          [helper]="'(' + lane.cards.length + ')'" />
        <div class="restock-lane-rule"></div>
      </div>
      @if (lane.cards.length === 0) {
        <tidy-row>
          <tidy-text
            [helper]="'No orders in this status.'" />
        </tidy-row>
      } @else {
        <div class="restock-lane-grid">
          @for (card of lane.cards; track card.id) {
            <tidy-card
              class="restock-order-card"
              [class.restock-card-picker-open]="card.showJobSelect"
              (click)="onCardClick(card)">
              <tidy-row
                [alignLastItemRight]="card.canAssignJob"
                class="vertical-align-center">
                <div class="restock-card-address">
                  <tidy-tag
                    [color]="card.addressColor"
                    [addressId]="card.addressId" />
                  <tidy-text
                    [body]="card.propertyName"
                    [translate]="false"
                    class="bold" />
                </div>
                @if (card.canAssignJob) {
                  <span class="restock-assign-trigger" (click)="$event.stopPropagation()">
                    <tidy-small-button
                      [text]="card.showJobSelect ? 'Close' : 'Assign to Job'"
                      [image]="card.showJobSelect ? 'assets/svg/close-outline.svg' : 'assets/svg/calendar-outline.svg'"
                      class="compact"
                      (buttonClick)="toggleJobSelect(card, $event)" />
                  </span>
                }
              </tidy-row>
              <!-- Attached-job chips: the jobs a pro will restock this order at
                   (card gCUZuCjf). The remove control swallows the click so it
                   doesn't also open the order. -->
              @if (card.assignedChips.length > 0) {
                <tidy-row class="restock-assigned-chips">
                  @for (chip of card.assignedChips; track chip.bookingId) {
                    <span class="restock-job-chip">
                      <tidy-image
                        [src]="chip.icon"
                        class="restock-job-chip-icon" />
                      <span class="restock-job-chip-label">{{ chip.label }}</span>
                      @if (chip.proInitials) {
                        <span class="restock-job-chip-initials">{{ chip.proInitials }}</span>
                      }
                      @if (chip.removable) {
                        <span
                          class="restock-job-chip-remove"
                          (click)="unassignJob(card, chip.bookingId, $event)"></span>
                      }
                    </span>
                  }
                </tidy-row>
              }

              <!-- Assign-to-Job dropdown, anchored to the card's top-right under
                   the trigger in the property row. Clicks stop propagation so they
                   don't open the order; a backdrop closes it on an outside click. -->
              @if (card.showJobSelect) {
                <div class="restock-job-backdrop" (click)="cancelJobSelect(card, $event)"></div>
                <div class="restock-job-dropdown" (click)="$event.stopPropagation()">
                      <div class="restock-job-search">
                        <tidy-image
                          [src]="'assets/svg/search-outline.svg'"
                          class="restock-job-search-icon" />
                        <input
                          class="restock-job-search-input"
                          type="text"
                          [placeholder]="'Search jobs' | translate"
                          [ngModel]="card.jobSearch"
                          (ngModelChange)="onJobSearch(card, $event)"
                          (click)="$event.stopPropagation()" />
                      </div>

                      @if (!card.jobItemsLoaded) {
                        <div class="restock-job-empty">
                          <tidy-text [helper]="'Loading jobs…'" />
                        </div>
                      } @else if (card.filteredJobItems.length === 0) {
                        <div class="restock-job-empty">
                          <tidy-text
                            [helper]="card.jobItems.length === 0 ? 'No upcoming jobs for this property.' : 'No matching jobs.'" />
                        </div>
                      } @else {
                        <div class="restock-job-list">
                          @for (item of card.filteredJobItems; track item.bookingId) {
                            <div
                              class="restock-job-option"
                              (click)="onJobSelected(card, item.bookingId, $event)">
                              <tidy-image
                                [src]="item.icon"
                                class="restock-job-option-icon" />
                              <div class="restock-job-option-main">
                                <span class="restock-job-option-label">{{ item.label }}</span>
                                @if (item.statusLabel) {
                                  <span class="restock-job-option-status">{{ item.statusLabel }}</span>
                                }
                              </div>
                              @if (item.proInitials) {
                                <span class="restock-job-option-initials">{{ item.proInitials }}</span>
                              }
                            </div>
                          }
                        </div>
                      }

                      <div class="restock-job-dropdown-footer">
                        <tidy-text
                          [actionBody]="'+ Add Job'"
                          (action)="goToAddJob(card)"
                          class="link" />
                      </div>
                </div>
              }

              <tidy-row>
                <tidy-text
                  [body]="card.title"
                  [translate]="false" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="card.metaLine" />
              </tidy-row>
            </tidy-card>
          }
        </div>
      }
    </div>
  }
  }
}

@if (selectedTab === 'items') {
<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (!loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (loaded) {
  <tidy-table
    #tidyTable
    class="restocking-table"
    [dataSource]="shownRows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    (sortChange)="sortChanged($event)"
    [showColumnLines]="false"
    [rowsToShow]="50"
    [allRowIsClickable]="true"
    (cellClick)="onTableColumnClick($event)"
    [infiniteScroll]="true"
    [totalRows]="totalRows"
    [skipEntrance]="true"
    (pageChange)="pageChange($event)"
    [blockSorting]="true" />
}
}

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'restocking'" (dismissed)="dismissAboutThisPage()" />
}